import apiPath from "../config/api-path";
import httpRequest from "../config/http-api";

export default {
  getModuleList(config, { success, error }) {
    const {
      module: { list },
    } = apiPath;
    return httpRequest.getRequest(list, success, error, config);
  },

  getModuleById(id, { success, error }) {
    const {
      module: { getById },
    } = apiPath;
    return httpRequest.getRequest(getById(id), success, error);
  },

  getModuleByCategoryId(id, { success, error }) {
    const {
      module: { filterByCategory },
    } = apiPath;
    return httpRequest.getRequest(filterByCategory(id), success, error);
  },

  createModule(data, { success, error }) {
    const {
      module: { create },
    } = apiPath;
    return httpRequest.postRequest(create, data, success, error);
  },
  updateModule(data, { success, error }) {
    const {
      module: { update },
    } = apiPath;
    return httpRequest.putRequest(update, data, success, error);
  },
};
